<template>
  <div class="p-6">
    <h1 class="text-2xl font-bold mb-4 text-[#f94368]">Gerenciar Banners ICP</h1>

    <!-- Formulário -->
    <div class="bg-white rounded-md shadow p-4 mb-6 max-w-5xl mx-auto">
      <h2 class="text-lg font-semibold mb-3">{{ editando ? 'Editar Banner' : 'Novo Banner' }}</h2>
      <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">

        <div>
          <label class="block text-sm font-medium">Nome</label>
          <input v-model="form.nome" class="input" />
        </div>

        <div>
          <label class="block text-sm font-medium">Ordem</label>
          <input v-model.number="form.ordem" type="number" class="input" />
        </div>

        <div>
          <label class="block text-sm font-medium">Data Início</label>
          <input v-model="form.dataInicio" type="date" class="input" />
        </div>

        <div>
          <label class="block text-sm font-medium">Data Fim</label>
          <input v-model="form.dataFim" type="date" class="input" />
        </div>

        <div>
          <label class="block text-sm font-medium">Ativo</label>
          <select v-model="form.ativo" class="input">
            <option :value="true">Ativo</option>
            <option :value="false">Inativo</option>
          </select>
        </div>

        <!-- Campo de upload de imagem somente na criação -->
        <div v-if="!editando">
          <label class="block text-sm font-medium">Imagem</label>
          <input type="file" accept="image/*" class="input" @change="carregarImagem" />
        </div>

        <div>
          <label class="block text-sm font-medium">Link</label>
          <input v-model="form.link" class="input"  />
        </div>

        <div class="md:col-span-2">
          <label class="block text-sm font-medium">Descrição</label>
          <textarea v-model="form.descricao" class="input" rows="3"></textarea>
        </div>

      </div>

      <button @click="salvar" :disabled="uploadEmAndamento" class="bg-[#f94368] text-white px-4 py-2 rounded disabled:opacity-50">
        {{ editando ? 'Atualizar' : 'Cadastrar' }}
      </button>
      <button v-if="editando" @click="cancelarEdicao" class="ml-2 text-sm text-gray-500">Cancelar</button>
    </div>

    <!-- Listagem -->
    <div class="bg-white shadow rounded p-4">
      <table class="w-full text-sm table-fixed">
        <thead class="border-b bg-gray-50">
          <tr>
            <th class="p-2 text-left w-1/8">Nome</th>
            <th class="p-2 text-left w-1/8">Ordem</th>
            <th class="p-2 text-left w-1/8">Ativo</th>
            <th class="p-2 text-left w-1/8">Data Início</th>
            <th class="p-2 text-left w-1/8">Data Final</th>
            <th class="p-2 text-left w-1/8">Banner</th>
            <th class="p-2 text-left w-1/8">Ações</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="banner in banners" :key="banner.id" class="border-b hover:bg-gray-200">
            <td class="p-2">{{ banner.nome }}</td>
            <td class="p-2">{{ banner.ordem }}</td>
            <td class="p-2">{{ banner.ativo ? 'Sim' : 'Não' }}</td>
            <td class="p-2">{{ formatarData(banner.dataInicio) }}</td>
            <td class="p-2">{{ formatarData(banner.dataFim) }}</td>
            <td class="p-2">
              <img v-if="banner.imagem" :src="`/banner-icp/${banner.imagem}`" :alt="banner.nome" class="w-60 rounded shadow mx-auto" />
            </td>
            <td class="p-2 space-x-2">
              <button @click="editar(banner)" class="text-blue-500">Editar</button>
              <button @click="deletar(banner.id)" class="text-red-500">Excluir</button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import api from '@/admin/services/api'

const banners = ref([])
const form = ref({
  id: null,
  nome: '',
  tipo: '',
  descricao: '',
  imagem: '',
  ativo: true,
  ordem: 0,
  dataInicio: '',
  dataFim: '',
  link: ''
})
const editando = ref(false)
const selectedFile = ref(null)
const uploadEmAndamento = ref(false)

const carregarBanners = async () => {
  const { data } = await api.get('/api/bannersicp/listar')
  banners.value = data.sort((a, b) => a.ordem - b.ordem)
}

const salvar = async () => {
  console.log('Salvando com dados:', form.value)

  try {
    if (uploadEmAndamento.value) {
      alert('Aguarde o envio da imagem antes de salvar!')
      return
    }

    if (editando.value) {
      await api.put(`/api/bannersicp/update/${form.value.id}`, form.value)
    } else {
      await api.post('/api/bannersicp/salvar', form.value)
    }

    await carregarBanners()
    cancelarEdicao()
  } catch (e) {
    console.error('Erro ao salvar banner:', e)
  }
}

const formatarData = (dataStr) => {
  if (!dataStr) return '-'
  const [ano, mes, dia] = dataStr.split('-')
  return `${dia}/${mes}/${ano}`
}

const carregarImagem = async (event) => {
  const file = event.target.files[0]
  if (!file) return

  selectedFile.value = file

  const formData = new FormData()
  formData.append('file', file)

  uploadEmAndamento.value = true

  try {
    const response = await api.post('/api/bannersicp/upload/banner', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
    console.log('Upload realizado:', response.data)

    form.value.imagem = response.data.nomeArquivo
    console.log('Imagem atribuída ao formulário:', form.value.imagem)
  } catch (e) {
    console.error('Erro ao enviar imagem:', e)
  } finally {
    uploadEmAndamento.value = false
  }
}

const editar = (banner) => {
  form.value = {
    id: banner.id,
    nome: banner.nome,
    tipo: banner.tipo,
    descricao: banner.descricao,
    imagem: banner.imagem,
    ativo: banner.ativo,
    ordem: banner.ordem,
    dataInicio: banner.dataInicio,
    dataFim: banner.dataFim,
    link: banner.link
  }
  editando.value = true
}

const deletar = async (id) => {
  if (confirm('Deseja realmente excluir este banner?')) {
    await api.delete(`/api/bannersicp/deletar/${id}`)
    await carregarBanners()
  }
}

const cancelarEdicao = () => {
  form.value = {
    id: null,
    nome: '',
    tipo: '',
    descricao: '',
    imagem: '',
    ativo: true,
    ordem: 0,
    dataInicio: '',
    dataFim: '',
    link: ''
  }
  selectedFile.value = null
  editando.value = false
}

onMounted(() => {
  carregarBanners()
})
</script>

<style scoped>
.input {
  @apply border border-gray-300 rounded px-3 py-2 w-full;
}
</style>
